import { Box } from "../Box"
import { TableProps, Table, TableDataTestIds } from "../Table"
import { PaginationProps, Pagination } from "../Pagination"
import * as styles from "./tableStyles"

export type TableWithPaginationDataTestIds = {
  table?: TableDataTestIds
  pagination?: string
}

export type TableWithPaginationProps<T extends Record<string, unknown>> = TableProps<T> &
  Omit<PaginationProps, "dataTestIds" | "css"> & {
    dataTestIds?: TableWithPaginationDataTestIds
  }

export const TableWithPagination = <T extends Record<string, unknown>>({
  containerCss,
  dataCount,
  pagination,
  dataTestIds,
  ...props
}: TableWithPaginationProps<T>) => (
  <Box css={styles.makeContainerStyle(containerCss)}>
    <Table dataTestIds={dataTestIds?.table} {...props} />
    <Pagination dataTestIds={{ root: dataTestIds?.pagination }} dataCount={dataCount} pagination={pagination} />
  </Box>
)

TableWithPagination.defaultProps = {
  dataTestIds: undefined,
}
